import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/home/index.vue";

import { useStore } from "@/store";
import { ElMessage } from "element-plus";
// const { userLoginInfo, openLogin } = storeToRefs(store);
// const { setUserLoginInfo, setOpenLogin } = store;

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import("../views/home/demo"),
  },
  {
    path: "/pages/wxGo",
    name: "wxGo",
    component: () => import("../views/wxGo"),
  },
  {
    path: "/chat",
    name: "chat",
    component: () => import("../views/chat"),
    meta: { requiresAuth: true },
  },
  {
    path: "/finance",
    name: "finance",
    component: () => import("../views/finance"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myApplication",
    name: "myApplication",
    component: () => import("../views/myApplication"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myApplicationForm",
    name: "myApplicationForm",
    component: () => import("../views/myApplication/form.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myDocuments",
    name: "myDocuments",
    component: () => import("../views/myDocuments"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myRecord",
    name: "myRecord",
    component: () => import("../views/myRecord"),
    meta: { requiresAuth: true },
  },
  {
    path: "/schoolSelectPlan",
    name: "schoolSelectPlan",
    component: () => import("../views/schoolSelectPlan"),
    meta: { requiresAuth: true },
  },
  {
    path: "/schoolSelectPlanForm",
    name: "schoolSelectPlanForm",
    component: () => import("../views/schoolSelectPlan/form.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myOrder",
    name: "myOrder",
    component: () => import("../views/myOrder"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // 检查路由是否需要登录
  if (to.meta.requiresAuth) {
    // 从 localStorage 获取登录用户信息
    const loginUser = localStorage.getItem("loginUser");
    if (loginUser) {
      // 已登录，继续导航
      next();
    } else {
      // 未登录，跳转到首页
      next("/");
      // 如果有登录弹窗组件，可以在这里触发显示
      const store = useStore();
      ElMessage.info("请先登录");
      store.setOpenLogin(false);
      setTimeout(() => {
        store.setOpenLogin(true);
      }, 500);
    }
  } else {
    // 不需要登录的路由，直接放行
    next();
  }
});

export default router;
